import React, {Component} from "react"
import {Breadcrumb} from "react-bootstrap"

class AdminPage extends Component {
  render() {
    return (
      <div>
        <div className="row border-bottom white-bg page-heading">
          <div className="col-lg-10">
            <h2>{this.props.title}</h2>
            <p>{this.props.desc}</p>
          </div>
          <div className="col-lg-2">
            <div className="pull-right m-b-md m-t-md">
              {this.props.topRightComponent}
            </div>
          </div>
        </div>


        <div className="ibox float-e-margins">

          <div className="ibox-content">
            <div className="m-b-md">
              <Breadcrumb>
                {this.props.breadcrumb.map((data) => (
                  data.active ?
                    <Breadcrumb.Item active className="font-bold">{data.label}</Breadcrumb.Item>
                    :
                    <Breadcrumb.Item href={data.url}>{data.label}</Breadcrumb.Item>

                ))}
              </Breadcrumb>
            </div>

            {this.props.children}
          </div>
        </div>

      </div>
    )
  }
}

export default AdminPage



// WEBPACK FOOTER //
// ./src/routes/admin/components/AdminPage.js